<template>
	<router-view name="offcanvas"></router-view>
	<router-view name="header"></router-view>
	<router-view></router-view>
	<router-view name="contact"></router-view>
	<router-view name="footer"></router-view>
</template>
